export const environment = {
  production: false,
  API_URL: 'https://test.dsp.billionbroadcaster.com/api',
  GOOGLE_MAP_KEY: 'AIzaSyAp7PXB0sH7PFhfPmYTiqP3ophRLN-zaCI',
  IMS_CLOUD_FRONT: 'https://dfeljlgwjhrm9.cloudfront.net/'
};